import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, mergeProps as _mergeProps, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "BaseGuard relative-position" }
const _hoisted_2 = {
  key: 0,
  class: "BaseGuard__overlay absolute-full flex flex-center cursor-not-allowed"
}
const _hoisted_3 = { class: "BaseGuard__message row items-center no-wrap gap-sm q-px-12 q-py-sm bg-error-20 rounded-32 transition" }
const _hoisted_4 = { class: "fs-13px fw-500 text-error-100" }

import useAccess from 'src/hook/useAccess'
import translate from 'src/common/helpers/language/translate'
import globalTranslateObject from 'src/translate/global.translate'

interface IProps {
  accessList: number[]
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseGuard', inheritAttrs: false },
  __name: 'BaseGuard',
  props: {
    accessList: {}
  },
  setup(__props: any) {




const { t: globalT } = translate(globalTranslateObject)

const { canPassAccess } = useAccess()

return (_ctx: any,_cache: any) => {
  const _component_k_icon = _resolveComponent("k-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _mergeProps({ class: "BaseGuard__content" }, _ctx.$attrs, {
      class: { 'BaseGuard__content--access-denied': !_unref(canPassAccess)(__props.accessList) }
    }), [
      _renderSlot(_ctx.$slots, "default")
    ], 16 /* FULL_PROPS */),
    (!_unref(canPassAccess)(__props.accessList))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "error", {}, () => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_k_icon, {
                name: "warning",
                color: "error-100",
                size: "24px"
              }),
              _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(globalT)('restricted_access')), 1 /* TEXT */)
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})